import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=22ade2c6&scoped=true&"
import script from "./MerchantList.vue?vue&type=script&lang=js&"
export * from "./MerchantList.vue?vue&type=script&lang=js&"
import style0 from "./MerchantList.vue?vue&type=style&index=0&id=22ade2c6&lang=scss&scoped=true&"
import style1 from "./MerchantList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./MerchantList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ade2c6",
  null
  
)

export default component.exports